if (!window.ejsShipInfoBound) {
  window.ejsShipInfoBound = true;

  let active = null;
  let closeTimer = null;
  let cutoffTimer = null;

  const canHover = () => window.matchMedia('(hover: hover)').matches;

  const formatDay = (date, locale) => date.toLocaleDateString(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  }).replace(/\.$/, '');

  const zone = 'America/Toronto';
  const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  const torontoParts = (date) => {
    const parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      weekday: 'short',
      hourCycle: 'h23'
    }).formatToParts(date).forEach((part) => {
      parts[part.type] = part.value;
    });
    let hour = Number(parts.hour);
    if (hour === 24) hour = 0;
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: hour,
      minute: Number(parts.minute),
      weekday: weekdays[parts.weekday] ?? 0
    };
  };

  const addDaysYmd = (year, month, day, days) => {
    const date = new Date(Date.UTC(year, month - 1, day));
    date.setUTCDate(date.getUTCDate() + days);
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  };

  const zonedTime = (year, month, day, hour, minute) => {
    const guess = Date.UTC(year, month - 1, day, hour, minute, 0);
    const parts = torontoParts(new Date(guess));
    const got = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, 0);
    const wanted = Date.UTC(year, month - 1, day, hour, minute, 0);
    return new Date(guess + (wanted - got));
  };

  const nextWindow = (now) => {
    const parts = torontoParts(now);
    const minutes = parts.hour * 60 + parts.minute;
    const fridayOpen = parts.weekday === 2 || parts.weekday === 3 || parts.weekday === 4 || (parts.weekday === 5 && minutes < 600);
    if (fridayOpen) {
      const friday = addDaysYmd(parts.year, parts.month, parts.day, (5 - parts.weekday + 7) % 7);
      return {
        ship: zonedTime(friday.year, friday.month, friday.day, 12, 0),
        deadline: zonedTime(friday.year, friday.month, friday.day, 10, 0),
        weekday: 5
      };
    }
    let untilTuesday = (2 - parts.weekday + 7) % 7;
    if (untilTuesday === 0) untilTuesday = 7;
    const tuesday = addDaysYmd(parts.year, parts.month, parts.day, untilTuesday);
    return {
      ship: zonedTime(tuesday.year, tuesday.month, tuesday.day, 12, 0),
      deadline: zonedTime(tuesday.year, tuesday.month, tuesday.day, 0, 0),
      weekday: 2
    };
  };

  const formatRemaining = (ms, french) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
    const pad = (value) => String(value).padStart(2, '0');
    if (french) {
      if (days > 0) return days + ' j ' + hours + ' h ' + pad(mins) + ' min ' + pad(secs) + ' sec';
      if (hours > 0) return hours + ' h ' + pad(mins) + ' min ' + pad(secs) + ' sec';
      if (mins > 0) return mins + ' min ' + pad(secs) + ' sec';
      return secs + ' sec';
    }
    if (days > 0) return days + (days > 1 ? ' days ' : ' day ') + hours + ' hr ' + pad(mins) + ' min ' + pad(secs) + ' sec';
    if (hours > 0) return hours + ' hr ' + pad(mins) + ' min ' + pad(secs) + ' sec';
    if (mins > 0) return mins + ' min ' + pad(secs) + ' sec';
    return secs + ' sec';
  };

  const addBusinessDays = (from, days) => {
    const start = torontoParts(from);
    let cursor = { year: start.year, month: start.month, day: start.day };
    let left = days;
    while (left > 0) {
      cursor = addDaysYmd(cursor.year, cursor.month, cursor.day, 1);
      const weekday = torontoParts(zonedTime(cursor.year, cursor.month, cursor.day, 12, 0)).weekday;
      if (weekday !== 0 && weekday !== 6) left -= 1;
    }
    return zonedTime(cursor.year, cursor.month, cursor.day, 12, 0);
  };

  const fillSteps = (panel) => {
    const lang = (document.documentElement.lang || 'fr').toLowerCase();
    const french = lang.startsWith('fr');
    const locale = french ? 'fr-CA' : 'en-CA';
    const now = new Date();
    let windowInfo = nextWindow(now);
    if (windowInfo.deadline.getTime() <= now.getTime()) windowInfo = nextWindow(new Date(windowInfo.deadline.getTime() + 60000));
    const placed = panel.querySelector('[data-step="placed"]');
    const ships = panel.querySelector('[data-step="ships"]');
    const delivered = panel.querySelector('[data-step="delivered"]');
    const cutoff = panel.querySelector('[data-cutoff]');
    if (placed) placed.textContent = formatDay(now, locale);
    if (ships) ships.textContent = formatDay(windowInfo.ship, locale);
    if (delivered) {
      const toUs = panel.getAttribute('data-ship-dest') === 'us';
      if (toUs) {
        const first = addBusinessDays(windowInfo.ship, 3);
        const last = addBusinessDays(windowInfo.ship, 4);
        delivered.textContent = formatDay(first, locale) + ' – ' + formatDay(last, locale);
      } else {
        delivered.textContent = formatDay(addBusinessDays(windowInfo.ship, 2), locale);
      }
    }
    if (cutoff) {
      const left = formatRemaining(windowInfo.deadline.getTime() - now.getTime(), french);
      const shipName = french
        ? (windowInfo.weekday === 2 ? 'mardi' : 'vendredi')
        : (windowInfo.weekday === 2 ? 'Tuesday' : 'Friday');
      cutoff.innerHTML = french
        ? 'Commandez dans <strong>' + left + '</strong> pour expédition ' + shipName + '.'
        : 'Order within <strong>' + left + '</strong> to ship ' + shipName + '.';
    }
  };

  const placePanel = (button, panel) => {
    const rect = button.getBoundingClientRect();
    const width = panel.offsetWidth;
    const height = panel.offsetHeight;
    let left = rect.left;
    if (left + width > window.innerWidth - 12) left = window.innerWidth - width - 12;
    if (left < 12) left = 12;
    let top = rect.bottom + 8;
    if (top + height > window.innerHeight - 8) top = Math.max(8, rect.top - height - 8);
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  };

  const closeActive = () => {
    clearInterval(cutoffTimer);
    cutoffTimer = null;
    if (!active) return;
    active.button.setAttribute('aria-expanded', 'false');
    active.panel.hidden = true;
    active.home.appendChild(active.panel);
    active = null;
  };

  const openPanel = (button) => {
    const home = button.closest('.ejs-ship-countries');
    const panel = home && home.querySelector('.ejs-ship-info__panel');
    if (!panel) return;
    if (active && active.button === button) return;
    closeActive();
    fillSteps(panel);
    clearInterval(cutoffTimer);
    cutoffTimer = setInterval(() => {
      if (active && active.panel === panel) fillSteps(panel);
    }, 1000);
    document.body.appendChild(panel);
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    active = { button, panel, home };
    placePanel(button, panel);
    requestAnimationFrame(() => {
      if (!active || active.panel !== panel) return;
      panel.querySelectorAll('.ejs-ship-info__track span').forEach((glow) => {
        glow.getAnimations().forEach((anim) => anim.cancel());
        glow.style.animation = 'none';
        const distance = glow.parentElement.getBoundingClientRect().width;
        const anim = glow.animate(
          [{ transform: 'translateX(-36px)' }, { transform: 'translateX(' + distance + 'px)' }],
          { duration: 3600, easing: 'linear', iterations: Infinity }
        );
        anim.startTime = document.timeline.currentTime;
      });
    });
  };

  const overActive = (node) => {
    if (!active || !node || !node.closest) return false;
    return node.closest('.ejs-ship-info') === active.button || node.closest('.ejs-ship-info__panel') === active.panel;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.ejs-ship-info');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      if (!canHover()) {
        if (active && active.button === button) closeActive();
        else openPanel(button);
      }
      return;
    }
    if (active && !(event.target.closest && event.target.closest('.ejs-ship-info__panel'))) closeActive();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeActive();
  });

  document.addEventListener('pointerover', (event) => {
    if (!canHover()) return;
    const button = event.target.closest && event.target.closest('.ejs-ship-info');
    if (button) {
      clearTimeout(closeTimer);
      openPanel(button);
      return;
    }
    if (overActive(event.target)) clearTimeout(closeTimer);
  });

  document.addEventListener('pointerout', (event) => {
    if (!canHover() || !active) return;
    if (!overActive(event.target)) return;
    if (overActive(event.relatedTarget)) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeActive, 120);
  });

  window.addEventListener('resize', closeActive);
}
